// Financial Trees Management Permissions

export const FINANCIAL_TREES_INDEX = 65;
export const FINANCIAL_TREES_CREATE = 66;
export const FINANCIAL_TREES_EDIT = 67;
export const FINANCIAL_TREES_DELETE = 68;

// Registered by the amer-laravel migration
// 2026_08_19_000002_add_financial_tree_and_contact_message_restore_permissions. The id
// below is the central-assigned approval number and must be confirmed against the central
// permission-key registry before release.
/** financial_trees.restore */
export const FINANCIAL_TREES_RESTORE = 1466;
